var Context = function Context() {
  this.level = 0;
};

Context.prototype.child = function child () {
  var child = Object.create(this);
  child.level++;
  return child;
};

module.exports = Context;
